import React from 'react';
import Main from './main';

interface Props {
  closeBusinessDrawer: () => void;
  showBusinessDrawer: boolean;
  panDb: any;
  businessDataStore:any;
  selectOrg:(arg0: string,arg1:string)=>void;
}

const BusinessDrawer: React.FC<Props> = ({
  showBusinessDrawer,
  closeBusinessDrawer,
  panDb,
  businessDataStore,
  selectOrg,
}) => (
  <Main
    showBusinessDrawer={showBusinessDrawer}
    closeBusinessDrawer={closeBusinessDrawer}
    panDb = {panDb}
    businessDataStore = {businessDataStore}
    selectOrg = {selectOrg}
  />
);

export default BusinessDrawer;
